import { produce } from 'immer';
import { CURRENT_EXPORT_VERSION, migrateSettings, } from 'nmr-load-save';
import { getLocalStorage, storeData } from '../../utility/LocalStorage';
import Workspaces from '../../workspaces';
import { addWorkspace } from './actions/addWorkspace';
import { analyzeSpectra, changeAnalysisColumnValueKey, deleteAnalysisColumn, setSpectraAnalysisPanelsPreferences, } from './actions/analyzeSpectra';
import { applyGeneralPreferences } from './actions/applyGeneralPreferences';
import { initPreferences } from './actions/initPreferences';
import { setMatrixGenerationOptions, addExclusionZone, deleteExclusionZone, toggleMatrixGenerationViewProperty, changeMatrixGenerationScale, changeMatrixGenerationStocsyChemicalShift, } from './actions/matrixGeneration';
import { removeWorkspace } from './actions/removeWorkspace';
import { setActiveWorkspace } from './actions/setActiveWorkspace';
import { setPanelsPreferences } from './actions/setPanelsPreferences';
import { setPreferences } from './actions/setPreferences';
import { setVerticalSplitterPosition } from './actions/setVerticalSplitterPosition';
import { setWorkspace } from './actions/setWorkspace';
import { mapWorkspaces } from './utilities/mapWorkspaces';
const LOCAL_STORAGE_SETTINGS_KEY = 'nmr-general-settings';
export const WORKSPACES_KEYS = {
    componentKey: `nmrium-component-workspace`,
    nmriumKey: `nmrium-file-workspace`,
};
export const WORKSPACES = [
    {
        key: 'default',
        label: Workspaces.default.label,
    },
    {
        key: 'process1D',
        label: Workspaces.process1D.label,
    },
    {
        key: 'exercise',
        label: Workspaces.exercise.label,
    },
    {
        key: 'prediction',
        label: Workspaces.prediction.label,
    },
    {
        key: 'assignment',
        label: Workspaces.assignment.label,
    },
    {
        key: 'embedded',
        label: Workspaces.embedded.label,
    },
    {
        key: 'simulation',
        label: Workspaces.simulation.label,
    },
];
export const preferencesInitialState = {
    version: CURRENT_EXPORT_VERSION,
    workspaces: {},
    originalWorkspaces: {},
    dispatch: () => null,
    workspace: {
        current: 'default',
        base: null,
    },
};
export function readSettings() {
    const localData = getLocalStorage(LOCAL_STORAGE_SETTINGS_KEY) || {
        version: CURRENT_EXPORT_VERSION,
        currentWorkspace: null,
        workspaces: {},
    };
    return migrateSettings(localData);
}
export function updateSettings(settings) {
    storeData(LOCAL_STORAGE_SETTINGS_KEY, JSON.stringify(settings));
}
export function initPreferencesState(state) {
    const localData = getLocalStorage(LOCAL_STORAGE_SETTINGS_KEY);
    const settings = readSettings();
    //  if the local setting version != current settings version number
    if (localData?.version !== CURRENT_EXPORT_VERSION) {
        updateSettings(settings);
    }
    const predefinedWorkspaces = mapWorkspaces(Workspaces, {
        source: 'predefined',
    });
    const localWorkspaces = mapWorkspaces(settings?.workspaces || {}, {
        source: 'user',
    });
    return {
        ...state,
        originalWorkspaces: { ...predefinedWorkspaces, ...localWorkspaces },
        workspaces: { ...predefinedWorkspaces, ...localWorkspaces },
        workspace: {
            current: settings?.currentWorkspace || 'default',
            base: null,
        },
    };
}
function innerPreferencesReducer(draft, action) {
    switch (action.type) {
        case 'INIT_PREFERENCES':
            return initPreferences(draft, action);
        case 'SET_PREFERENCES':
            return setPreferences(draft, action);
        case 'SET_PANELS_PREFERENCES':
            return setPanelsPreferences(draft, action);
        case 'SET_WORKSPACE':
            return setWorkspace(draft, action);
        case 'SET_ACTIVE_WORKSPACE':
            return setActiveWorkspace(draft, action);
        case 'ADD_WORKSPACE':
            return addWorkspace(draft, action);
        case 'REMOVE_WORKSPACE':
            return removeWorkspace(draft, action);
        case 'APPLY_General_PREFERENCES':
            return applyGeneralPreferences(draft, action);
        case 'ANALYZE_SPECTRA':
            return analyzeSpectra(draft, action);
        case 'CHANGE_ANALYSIS_COLUMN_VALUE_KEY':
            return changeAnalysisColumnValueKey(draft, action);
        case 'DELETE_ANALYSIS_COLUMN':
            return deleteAnalysisColumn(draft, action);
        case 'SET_SPECTRA_ANALYSIS_PREFERENCES':
            return setSpectraAnalysisPanelsPreferences(draft, action);
        case 'SET_MATRIX_GENERATION_OPTIONS':
            return setMatrixGenerationOptions(draft, action);
        case 'ADD_MATRIX_GENERATION_EXCLUSION_ZONE':
            return addExclusionZone(draft, action);
        case 'DELETE_MATRIX_GENERATION_EXCLUSION_ZONE':
            return deleteExclusionZone(draft, action);
        case 'TOGGLE_MATRIX_GENERATION_VIEW_PROPERTY':
            return toggleMatrixGenerationViewProperty(draft, action);
        case 'SET_VERTICAL_SPLITTER_POSITION':
            return setVerticalSplitterPosition(draft, action);
        case 'CHANGE_MATRIX_GENERATION_SCALE':
            return changeMatrixGenerationScale(draft, action);
        case 'CHANGE_MATRIX_GENERATION_STOCSY_CHEMICAL_SHIFT':
            return changeMatrixGenerationStocsyChemicalShift(draft, action);
        default:
            return draft;
    }
}
const preferencesReducer = produce(innerPreferencesReducer);
export default preferencesReducer;
